import { useCallback } from 'react'
import { TAutocompleteValue, TAutocompleteBaseChangeHandler } from '../types'
import * as TypeGuards from '../utils/typeGuards'
import { useAutocompleteInputState, TInputChangeHandler } from './useAutocompleteInputState'
import { useAutocompleteState } from './useAutocompleteState'

interface IUseAutocompleteState {
  /**
   * @example 'Jim'
   */
  defaultInputValue?: string
  /**
   * @default null
   */
  defaultValue?: TAutocompleteValue
}

export interface IUseAutocompleteReturn {
  inputValue: string
  inputChangeHandler: TInputChangeHandler
  value: TAutocompleteValue
  changeHandler: TAutocompleteBaseChangeHandler
}

/**
 * Manages typed state for <AutocompleteBase /> when adding an option
 */
export const useAutocompleteAddOption = ({
  defaultInputValue = '',
  defaultValue = null,
}: IUseAutocompleteState): IUseAutocompleteReturn => {
  const [value, setValue] = useAutocompleteState(defaultValue)
  const [inputValue, inputChangeHandler] = useAutocompleteInputState(defaultInputValue)

  const changeHandler: TAutocompleteBaseChangeHandler = useCallback(
    (_, newValue) => {
      if (TypeGuards.isAutocompleteAddOption(newValue)) {
        const { onClick } = newValue || {}
        if (onClick) {
          onClick()
        }
      } else {
        setValue(newValue)
      }
    },
    [setValue]
  )

  return {
    inputValue,
    inputChangeHandler,
    value,
    changeHandler,
  }
}
